// extracted by mini-css-extract-plugin
export var columnList = "_ik-0";